module.exports = {
  dateFormat: 'dd/mm/yyyy',
  loading: 'Laden',
  or: 'of',
  navigation: {
    'advisory-tool': 'Advies',
    systems: 'Overzicht Systemen',
  },
  vat: {
    excluded: 'excl. btw',
    included: 'incl. btw',
  },
  validation: {
    maxCharacters: 'max. {amount} karakters',
  },
};



// WEBPACK FOOTER //
// ./js/lang/nl/general.js